/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const BtnWrap = styled.div`
  display: flex;
  margin-left: auto;
  margin-top: -4px;
  margin-bottom: 4px;
`;

export const MonthName = styled.span`
  margin-left: 8px;
  color: ${Palette.PrimaryGray._900};
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;
